module.exports = {
  key: '6ce665a4d6b84d5d271bd5b8c306f12c',
  base: "https://api.openweathermap.org/data/2.5/", 
};
